import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
  `;

  const cardHeader = css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.navy["1"]};
    padding: 0px 16px;
  `;

  const headerRow = css`
    padding: 20px 0 0 20px;
    align-items: center;
  `;

  const title = css`
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: ${theme.colors.navy["1"]};
  `;

  const hr = css`
    margin-left: 30px;
    margin-right: 30px;
  `;

  const rightAlignColumns = css`
    .quantityCol,
    .mfrPriceCol,
    .discountCol,
    .blendedCostCol,
    .markupCol,
    .blendedPriceCol,
    .extCostCol,
    .extPriceCol {
      text-align: right;
    }

    .cellCol1 > div,
    .cellCol2 > div,
    .cellCol3 > div,
    .cellCol4 > div,
    .cellCol5 > div,
    .cellCol6 > div,
    .cellCol7 > div,
    .cellCol8 > div {
      justify-content: flex-end !important;
    }

    tbody[data-target=".multi-collapsetotal"] td {
      border-top: 3px solid ${theme.colors.navy["1"]};
    }

    tbody[data-target=".multi-collapsetotal"],
    tbody[data-target=".multi-collapseprofit"],
    tbody[data-target=".multi-collapsemargin"] {
      background-color: ${theme.colors.white} !important;
      border-top: none !important;
    }

    tbody[data-target=".multi-collapsetotal"] tr {
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapseprofit"] tr {
      padding-top: 4px;
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapsemargin"] tr {
      padding-top: 4px;
    }

    tbody[data-target=".multi-collapseprofit"] td,
    tbody[data-target=".multi-collapsemargin"] td {
      border: none;
    }
  `;

  const totalRow = css`
    font-weight: 700;
  `;

  return {
    page,
    card,
    cardHeader,
    headerRow,
    title,
    hr,
    rightAlignColumns,
    totalRow,
  };
};

export default useStyles;
